import { EventEmitter } from '@angular/core';
import { DeviceService } from './device.service';
import { EnhanceDeviceService } from './enhance-device.service';
import { SocketService } from './socket.service';

class emitData {
  type: any;
  data: any;
}

class option {
  filter: any;
  digest: any;
}

export class TrackerService {
  removeListener(arg0: string, changeListener: (device: any) => void) {
    throw new Error('Method not implemented.');
  }

  devices: any[] = [];
  devicesBySerial = Object.create(null);
  digestTimer: any;
  lastDigest: any;
  // enhanceDeviceService: EnhanceDeviceService;
  on = EventEmitter.prototype;
  //wire = require('./')
  //log = require('../util/logger').createLogger('wire:router')
  trackerEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  private options: option;
  private socketService: SocketService;
  private enhanceDeviceService: EnhanceDeviceService;
  private deviceService: DeviceService;

  constructor(
    options: option,
    socketService: SocketService,
    enhanceDeviceService: EnhanceDeviceService,
    deviceService: DeviceService
  ) {
    this.options = options;
    this.socketService = socketService;
    this.enhanceDeviceService = enhanceDeviceService;
    this.deviceService = deviceService;

    this.socketService.scoped().on('device.add', this.addListener.bind(this));
    this.socketService.scoped().on('device.change', this.changeListener.bind(this));
    this.socketService.scoped().on('device.remove', this.changeListener.bind(this));
    this.socketService.scoped().on('device.addGroupDevices', this.addGroupDevicesListener.bind(this));
    this.socketService.scoped().on('device.removeGroupDevices', this.removeGroupDevicesListener.bind(this));
    this.socketService.scoped().on('device.updateGroupDevice', this.updateGroupDeviceListener.bind(this));
  }

  add(device: any): void {
    this.addListener({
      important: true,
      data: device
    });
  }

  private addListener(event: any): void {
    const device = this.get(event.data);

    if (device) {

      this.modify(device, event.data);
      this.notify(event);
    } else {
      if (this.options.filter(event.data)) {


        this.insert(event.data);
        this.notify(event);
      }
    }
  }

  private changeListener(event: any): void {


    const device = this.get(event.data);
    if (device) {
      this.modify(device, event.data);
      if (!this.options.filter(device)) {
        this.remove(device);
      }
      this.notify(event);
    }
  }

  private addGroupDevicesListener(event: any): Promise<any> {
    return Promise.all(
      event.devices.map((serial: string) => this.deviceService.load(serial))
    )
      .then((_devices: any[]) => {
        _devices.forEach((device: any) => {
          if (device && typeof this.devicesBySerial[device.serial] === 'undefined') {
            this.insert(device);
            this.notify(event);
          }
        });
      });
  }

  private removeGroupDevicesListener(event: any): void {
    event.devices.forEach((serial: string) => {
      if (typeof this.devicesBySerial[serial] !== 'undefined') {
        this.remove(this.devices[this.devicesBySerial[serial]]);
        this.notify(event);
      }
    });
  }

  private updateGroupDeviceListener(event: any): void {
    const device = this.get(event.data);
    if (device) {
      this.modify(device, event.data);
      this.notify(event);
    }
  }

  private insert(data: any): void {


    this.devicesBySerial[data.serial] = this.devices.push(data) - 1;
    this.sync(data);

    let filterData = new emitData();
    filterData.type = 'add';
    filterData.data = data;

    this.trackerEventEmitter.emit(filterData);
  }

  private modify(data: any, newData: any): void {

    Object.assign(data, newData);

    this.sync(data);

    let filterData = new emitData();
    filterData.type = 'change';
    filterData.data = data;

    this.trackerEventEmitter.emit(filterData);
  }

  private remove(data: any): void {
    const index = this.devicesBySerial[data.serial];
    if (index >= 0) {
      this.devices.splice(index, 1);
      delete this.devicesBySerial[data.serial];
      for (const serial in this.devicesBySerial) {
        if (this.devicesBySerial.hasOwnProperty(serial) && this.devicesBySerial[serial] > index) {
          this.devicesBySerial[serial]--;
        }
      }
      this.sync(data);

      let filterData = new emitData();
      filterData.type = 'remove';
      filterData.data = data;

      this.trackerEventEmitter.emit(filterData);
    }
  }

  sync(data: any) {
    // usable IF device is physically present AND device is online AND
    // preparations are ready AND the device has no owner or we are the
    // owner
    // this.enhanceDeviceService.enhance(data);

    data.usable = data.present && data.status === 3 && data.ready && (!data.owner || data.using);

    // Make sure we don't mistakenly think we still have the device
    if (!data.usable || !data.owner) {
      data.using = false
    }
    // console.trace(this.sync.name+' sync function');
    // console.log('In sync function \ndevice.usable: ',data.usable,
    //   '\ndevice.present: ',data.present,
    //   '\ndevice.status: ',data.status,
    //   '\ndevice.ready: ',data.ready,
    //   '\ndevice.owner: ',data.owner,
    //   '\ndevice.using: ',data.using,
    //   '\ndata.usable = data.present && data.status === 3 && data.ready && !data.owner || data.using',
    //   '\nif (!data.usable || !data.owner) {data.using = false}'
    // );


    this.enhanceDeviceService.enhance(data);

  }

  private get(data: any): any {
    return this.devices[this.devicesBySerial[data.serial]];
  }

  private notify(event: any): void {
    if (!this.options.digest) {
      return;
    }

    if (event.important) {
      window.requestAnimationFrame(this.digest.bind(this));
    } else {
      if (!this.digestTimer) {
        const delta = Date.now() - this.lastDigest;
        if (delta > 1000) {
          this.digest();
        } else {
          this.digestTimer = setTimeout(this.digest.bind(this), delta);
        }
      }
    }
  }

  private digest(): void {
    // if (!this.$scope.$$phase) {
    //     this.$scope.$digest();
    // }
    // this.lastDigest = Date.now();
    // this.digestTimer = null;
  }

  // public removeListener = (message, handler) => {
  //   return removeEventListener.call(
  //     this
  //   , message.$code
  //   , handler
  //   )
  // }

  // public handler = () => {
  //   return (channel, data) => {
  //     let wrapper = this.wire.Envelope.decode(data)
  //     let type = this.wire.ReverseMessageType[wrapper.type]

  //     if (type) {
  //       this.emit(
  //         wrapper.type
  //       , wrapper.channel || channel
  //       , this.wire[type].decode(wrapper.message)
  //       , data
  //       )
  //       this.emit(
  //         'message'
  //       , channel
  //       )
  //     }
  //     else {
  //       this.log.warn(
  //         'Unknown message type "%d", perhaps we need an update?'
  //       , wrapper.type
  //       )
  //     }
  //   }.bind(this)
  // }

}
